import { Injectable } from '@angular/core';
import { PlaceGridLayer } from './place-grid-layer.model';


@Injectable({
    providedIn: 'root'
})
export class MapPlacesGridService { 

    layers: PlaceGridLayer[] = [];
    provinces:{id?:any,name?:any}[] = [];

    constructor() { }


    getLayerIcon(type): string {

        let icon = "";

        switch (type) {

            case "fa-gamepad-modern":
            case 18:
                icon += "mdi-gamepad-variant-outline !tw-text-red-500"
                break;
            case "fa-place-of-worship":
            case 21:
                icon += "mdi-mosque-outline tw-text-blue-500"
                break;
            case "fa-duotone fa-book-circle-arrow-up":
            case 22:
                icon += "mdi-book-open-page-variant-outline tw-text-amber-500"
                break;
            case "fa-theater-masks":
            case 14:
                icon += "mdi-drama-masks tw-text-pink-500"
                break;
            case "fa-hand-holding-seedling":
            case 20:
                icon += "mdi-sprout-outline tw-text-green-500"
                break;
            case "fa-camera-movie":
            case 19:
                icon += "mdi-movie-roll tw-text-stone-500"
                break;
            case "fa-solid fa-gavel":
            case 23:
                icon += "mdi-gavel tw-text-slate-500"
                break;
            case "fa-book-quran":
            case 16:
                icon += "mdi-star-crescent tw-text-cyan-500"
                break;
            case "fa-books":
            case 17:
                icon += "mdi-bookshelf !tw-text-violet-500"
                break;

            default:
                break;
        }

        return icon;


    }

}



